import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Mail, Phone, Linkedin, Download } from 'lucide-react';
export function Contact() {
  const handleDownloadResume = () => {
    window.open('https://heyzine.com/flip-book/2eee1db339.html', '_blank');
  };
  return <Section id="contact" background="navy" className="text-center relative overflow-hidden" data-id="element-74">
      {/* Silver Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1e3a8a] via-[#1e293b] to-[#0f172a]" data-id="element-75"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-bl from-gray-400/10 via-transparent to-transparent blur-3xl" data-id="element-76"></div>

      <div className="relative z-10" data-id="element-77">
        <FadeIn data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-200 to-white mb-6 drop-shadow-lg" data-id="element-79">
            Let's Connect
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-12" data-id="element-80">
            If you are seeking a strategic leader to drive transformation,
            improve execution, and deliver measurable results, I'd welcome the
            opportunity to connect.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16" data-id="element-81">
          <FadeIn delay={0.1} className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 flex flex-col items-center hover:bg-white/10 transition-colors" data-id="element-82">
            <div className="bg-gradient-to-br from-gray-300/20 to-blue-300/20 p-4 rounded-full mb-4" data-id="element-83">
              <Mail className="w-8 h-8 text-white" data-id="element-84" />
            </div>
            <h3 className="text-white font-semibold mb-2" data-id="element-85">Email</h3>
            <a href="mailto:albertprevite@gmail.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-86">
              albertprevite@gmail.com
            </a>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 flex flex-col items-center hover:bg-white/10 transition-colors" data-id="element-87">
            <div className="bg-gradient-to-br from-gray-300/20 to-blue-300/20 p-4 rounded-full mb-4" data-id="element-88">
              <Phone className="w-8 h-8 text-white" data-id="element-89" />
            </div>
            <h3 className="text-white font-semibold mb-2" data-id="element-90">Phone</h3>
            <a href="tel:202-870-7859" className="text-gray-300 hover:text-white transition-colors" data-id="element-91">
              202-870-7859
            </a>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 flex flex-col items-center hover:bg-white/10 transition-colors" data-id="element-92">
            <div className="bg-gradient-to-br from-gray-300/20 to-blue-300/20 p-4 rounded-full mb-4" data-id="element-93">
              <Linkedin className="w-8 h-8 text-white" data-id="element-94" />
            </div>
            <h3 className="text-white font-semibold mb-2" data-id="element-95">LinkedIn</h3>
            <a href="https://www.linkedin.com/in/albertprevite/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-96">
              linkedin.com/in/albertprevite
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} className="flex justify-center" data-id="element-97">
          <Button variant="primary" onClick={handleDownloadResume} className="bg-gradient-to-r from-gray-200 to-gray-300 text-[#1e3a8a] hover:from-white hover:to-gray-200 border-none text-lg px-8 py-4 shadow-xl shadow-white/10 font-semibold" data-id="element-98">
            <Download className="mr-2 w-5 h-5" data-id="element-99" />
            View Resume
          </Button>
        </FadeIn>
      </div>
    </Section>;
}